/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bp_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch modes to get vapor pressure from a temperature instead.`)
};

const es_bp_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambia de modo para obtener la presión de vapor a partir de una temperatura.`)
};

const de_bp_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wechseln Sie den Modus, um stattdessen den Dampfdruck aus einer Temperatur zu ermitteln.`)
};

const nl_bp_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wissel van modus om in plaats daarvan de dampspanning uit een temperatuur te berekenen.`)
};

const fr_bp_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changez de mode pour obtenir la pression de vapeur à partir d'une température.`)
};

const it_bp_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambia modalità per ottenere la tensione di vapore a partire da una temperatura.`)
};

const pt_br2_bp_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterne os modos para obter a pressão de vapor a partir de uma temperatura.`)
};

const pt_bp_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mude de modo para obter a pressão de vapor a partir de uma temperatura.`)
};

const ja_bp_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`モードを切り替えると、温度から蒸気圧を求めることもできます。`)
};

const zh_bp_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换模式可改为从温度求出蒸气压。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bp_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bp_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bp_ex3", locale)
	if (locale === "en") return en_bp_ex3(inputs)
	if (locale === "es") return es_bp_ex3(inputs)
	if (locale === "de") return de_bp_ex3(inputs)
	if (locale === "nl") return nl_bp_ex3(inputs)
	if (locale === "fr") return fr_bp_ex3(inputs)
	if (locale === "it") return it_bp_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_bp_ex3(inputs)
	if (locale === "pt") return pt_bp_ex3(inputs)
	if (locale === "ja") return ja_bp_ex3(inputs)
	return zh_bp_ex3(inputs)
};